import { t } from "i18next";
import DBModal from "../../../../component/global/DBModal";
import { useContext, useState } from "react";
import DBButton from "../../../../component/global/DBButton";
import {
    SETTING_EDIT_ITEMS_EXCEL,
    SETTING_EDIT_ITEMS_POST,
    SETTING_IMPORT_ITEMS_EXCEL,
    SETTING_IMPORT_ITEMS_POST,
} from "../../../../helperData/ApiAddress";
import axios from "axios";
import { ToastContext } from "../../../../component/global/ToastContext";
import DBUpload from "../../../../component/global/DBUpload";
import DBSpinner from "../../../../component/global/DBSpinner";

export default function GroupAddEditModal({
    show,
    onHide,
    itemType,
    onSuccess,
}) {
    const [modalTab, setModalTab] = useState(0);
    const toast = useContext(ToastContext);
    const [uploadProgress, setUploadProgress] = useState(0);

    const getExcelFile = () => {
        let EXCEL_FILE;
        if (modalTab === 0) {
            EXCEL_FILE = SETTING_IMPORT_ITEMS_EXCEL.replace(
                "{id}",
                itemType.id
            );
        } else {
            EXCEL_FILE = SETTING_EDIT_ITEMS_EXCEL.replace("{id}", itemType.id);
        }
        axios
            .get(EXCEL_FILE, {
                responseType: "blob",
                headers: {
                    Authorization: `Bearer ${window.sessionStorage.auth}`,
                },
            })
            .then((response) => {
                let blob = new Blob([response.data]);
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "items.xlsx");
                document.body.appendChild(link);
                link.click();
            })
            .catch((e) => {
                toast(
                    t("Src.Layouts.Settings.Modals.ItemModal.ExcelDanger"),
                    "danger"
                );
            });
    };

    const uploadExcelFile = (excelFile) => {
        let UPLOAD_API;
        if (modalTab === 0) {
            UPLOAD_API = SETTING_IMPORT_ITEMS_POST.replace("{id}", itemType.id);
        } else {
            UPLOAD_API = SETTING_EDIT_ITEMS_POST.replace("{id}", itemType.id);
        }
        setUploadProgress(0);

        var formData = new FormData();

        formData.append("file", excelFile);

        axios
            .post(UPLOAD_API, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${window.sessionStorage.auth}`,
                    "Content-Disposition": "attachment; filename=file",
                },
                onUploadProgress: (ProgressEvent) => {
                    const { loaded, total } = ProgressEvent;
                    let percent = Math.floor((loaded * 100) / total);
                    setUploadProgress(percent);
                },
            })
            .then((r) => {
                onSuccess?.();
                onHide();
                setUploadProgress(0);
            })
            .catch((e) => {
                setUploadProgress(0);
                toast(
                    t("Src.Layouts.Settings.Modals.ItemModal.File.Err"),
                    "danger"
                );
            });
    };

    return (
        <DBModal
            show={show}
            onHide={onHide}
            className="group-add-edit"
            minWidth={600}
        >
            <DBModal.Header
                closeBtn={onHide}
                title={t("items.add.edit.group")}
            />

            <DBModal.Tab
                tabs={[
                    t("items.modal.tab.add.group"),
                    t("items.modal.tab.edit.group"),
                ]}
                onChange={(tab) => setModalTab(tab)}
                selected={modalTab}
                selectedColor="#2e71fc"
            />
            <DBModal.Content>
                {modalTab === 0 && (
                    <>
                        <div className="group-con">
                            <div>{t("items.stage.1")}</div>
                            {t("items.group.upload.p1")}
                        </div>
                        <div></div>
                        <div className="group-con">
                            <div>{t("items.stage.2")}</div>
                            {t("items.group.upload.p2")}
                        </div>
                        <div className="button-con">
                            <DBButton
                                outlined
                                caption={t("items.group.download.template")}
                                onClick={getExcelFile}
                            />
                            <DBUpload
                                disabled={uploadProgress > 0}
                                accept=".xlsx"
                                maxSize={1024 * 1024 * 5}
                                caption={t("upload.file")}
                                onChange={(e) => {
                                    uploadExcelFile(e.target.files[0]);
                                }}
                            />
                        </div>
                    </>
                )}
                {modalTab === 1 && (
                    <>
                        <div className="group-con">
                            <div>{t("items.stage.1")}</div>
                            {t("items.group.upload.p3")}
                        </div>
                        <div></div>
                        <div className="group-con">
                            <div>{t("items.stage.2")}</div>
                            {t("items.group.upload.p4")}
                        </div>

                        <div className="button-con">
                            <DBButton
                                outlined
                                caption={t(
                                    "items.group.download.template.edit"
                                )}
                                onClick={getExcelFile}
                            />
                            <DBUpload
                                disabled={uploadProgress > 0}
                                accept=".xlsx"
                                maxSize={1024 * 1024 * 5}
                                caption={t("upload.file")}
                                onChange={(e) => {
                                    uploadExcelFile(e.target.files[0]);
                                }}
                            />
                        </div>
                    </>
                )}
                {uploadProgress > 0 && (
                    <div>
                        <DBSpinner
                            tip={
                                t("uploading.file") +
                                " (" +
                                uploadProgress +
                                t("uploading.file.percent") +
                                ")"
                            }
                        />
                    </div>
                )}
            </DBModal.Content>
        </DBModal>
    );
}
